/* eslint-disable import/no-anonymous-default-export */
import React from 'react';

import { IntegrationsContext } from './IntegrationsContext';

export default () => React.useContext(IntegrationsContext);
